module.exports = __webpack_public_path__ + "assets/img/86.3a2a612c.png";